/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step2_AiInputs */

const en_dr_step2_ai = /** @type {(inputs: Dr_Step2_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assembles personas from participants' cards — never invents one`)
};

const id_dr_step2_ai = /** @type {(inputs: Dr_Step2_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun persona dari kartu peserta — tidak pernah mengarang sendiri`)
};

/**
* | output |
* | --- |
* | "Assembles personas from participants' cards — never invents one" |
*
* @param {Dr_Step2_AiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step2_ai = /** @type {((inputs?: Dr_Step2_AiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step2_AiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step2_ai(inputs)
	return en_dr_step2_ai(inputs)
});